<template>
  <div>
    <van-nav-bar title="盘点" left-text="返回" left-arrow @click-left="onClickLeft">
      <template #right>
        <van-icon name="wap-home-o" size="18" @click="toHome"/>
      </template>
    </van-nav-bar>
    <div>
      <van-search
        v-model="searchParam.storeName"
        show-action
        label="商品名"
        placeholder="请输入商品名关键词"
        @search="onSearch"
        @clear="onSearchClear"
        @cancel="onSearchClear"
      >
        <template #action>
          <div @click="onInputOrder" style="color: #07c160">{{ orderDes }}</div>
        </template>
      </van-search>
    </div>
    <div style="display: flex; justify-content:center; align-items: center; padding-top: 2px;">
      <el-link class="underline-link" type="primary"  :underline="true" style="font-size: 24px" @click="toProductCheckByFactory()">查看公司纬度</el-link>
    </div>
    <div class="van-address-list" type="primary" style="padding-bottom: 0; padding-top: 2px;">
      <div v-for="item in dataList" :key="item.id" :name="item.id">
        <div class="van-address-item" style="margin-bottom: 5px;">
          <div class="van-cell van-cell--borderless">
            <div class="van-cell__value van-cell__value--alone van-address-item__value">
              <div class="van-address-item__name">
                <span style="margin-right: 3px;">{{ item.keyword }}</span>
              </div>
              <div class="van-address-item__address">
                {{ item.factoryName }}
              </div>
              <div class="van-address-item__address">
                <el-link type="primary">量:{{ item.stock }}</el-link>
                <el-divider direction="vertical"></el-divider>
                <el-link style="text-decoration: underline;" underline type="danger" @click="showDiffCostPopup(item)"
                         v-if="item.subList && item.subList.length > 0">
                  <span>更多</span>
                </el-link>
                <el-link type="danger" v-else>
                  <span>价:</span>{{ item.cost }}
                </el-link>
                <el-divider direction="vertical"></el-divider>
                <el-link type="success">额:{{ item.amount }}</el-link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <van-popup v-model="isDiffCostPopShow" position="bottom" :style="{ height: '40%' }">
      <div class="van-address-list" style="padding-bottom: 0">
        <div v-for="item in diffCostData.subList" :key="item.id" :name="item.id">
          <div class="van-address-item" style="margin-bottom: 5px;">
            <div class="van-cell van-cell--borderless">
              <div class="van-cell__value van-cell__value--alone van-address-item__value">
                <div class="van-address-item__name">
                  <span style="margin-right: 3px;">{{ diffCostData.keyword }}</span>
                </div>
                <div class="van-address-item__address">
                  {{ diffCostData.factoryName }}
                </div>
                <div class="van-address-item__address">
                  <el-link style="margin-right: 6px;">{{ item.sku }}</el-link>
                </div>
                <div class="van-address-item__address">
                  <el-link type="primary">量:{{ item.stock }}</el-link>
                  <el-divider direction="vertical"></el-divider>
                  <el-link type="danger">价:{{ item.cost }}</el-link>
                  <el-divider direction="vertical"></el-divider>
                  <el-link type="success">额:{{ item.amount }}</el-link>
                </div>
              </div>
              <!--                <van-icon class="van-address-item__edit" name="more-o" />-->
            </div>
          </div>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import {AddressList, Card, List, Loading, NavBar, Notify, PullRefresh, Search, Switch, Tag} from 'vant';

import * as analysisService from "@/api/admin/analysis";


export default {
  components: {
    [Tag.name]: Tag,
    [Card.name]: Card,
    [Search.name]: Search,
    [Loading.name]: Loading,
    [PullRefresh.name]: PullRefresh,
    [List.name]: List,
    [Notify.name]: Notify,
    [AddressList.name]: AddressList,
    [NavBar.name]: NavBar,
    [Switch.name]: Switch
  },
  name: "StockOperateLog",
  data() {
    return {
      searchParam: {
        storeName: '',
      },
      orderChecked: true,
      dataList: [],
      searchParamValue: '',
      searchPopupShow: false,
      isDiffCostPopShow: false,
      diffCostData: [],
      orderDes: '库存排序'
    };
  },
  created() {
    this.onLoad()
  },
  methods: {
    onLoad() {
      let that = this;
      analysisService.getProductCheck(this.searchParam).then(res => {
        if (res.status === 200) {
          that.dataList = res.data
        }
      })
    },
    showDiffCostPopup(data) {
      this.diffCostData = data
      this.isDiffCostPopShow = true
    },
    onRefresh() {
      // 清空列表数据
      this.dataList = [];
      // 重新加载数据
      this.onLoad();
    },
    resetData() {
      this.pages = {
        perPage: 8,
        currPage: 1,
        pageCount: 3
      };
      this.loading = false;
      this.finished = false;
      this.refreshing = false;
    },
    onSearch() {
      this.onRefresh()
    },
    onSearchClear() {
      this.searchParam.storeName = null
      this.onRefresh();
    },
    onInputOrder() {
      if (this.orderChecked) {
        this.orderChecked = false
        this.orderDes = '库存排序'
        this.searchParam.orderDes = 'stock'
      } else {
        this.orderChecked = true
        this.orderDes = '公司排序'
        this.searchParam.orderDes = 'factoryName'
      }
      this.onRefresh()
    },
    onMerge() {
      this.$router.push({path: '/order/debt/merge/' + this.debt.userId + '/' + this.debt.id})
    },
    toHome() {
      this.$router.push({path: '/index'})
    },
    toProductCheckByFactory() {
      this.$router.push({path: '/statistics/productCheckByFactory'})
    },
    onClickLeft() {
      this.$router.go(-1);
    },
    initData() {
      adminStockService.getStockOperateLog().then(res => {
        console.log(res)
        this.debt = res
        this.debtChildren = res.children
        this.timelines = res.timelines
        this.timelineActive = this.timelines - 1
      });
    },
    toInfo(item) {
      console.log(item)
      if (item.type == 0) {
        this.$router.push({path: '/order/info/' + item.orderId})
      } else if (item.type == 1 && this.$route.params.debtId != item.id) {
        this.$router.push({path: '/order/debt/info/' + item.id})
      }
    },
  },
};
</script>

<style lang="less">
.underline-link {
  text-decoration: underline;
}
</style>
